import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import FilterListPriceUpload from "./FilterListPriceUpload"
import Modal from "../../components/Common/Modal"
import Pagination from "../../components/Common/Pagination"
import Table from "../../components/Tables/index"
import { userRoles } from "../../components/Utility/userRoles"
import {
    useGetAllListPrice,
    useGetAllPartNumbers,
    useGetCurrenyList,
    useGetEanNumbers,
    useGetPriceLevelIdentifiers,
    useGetPriceTableIds,
    useGetSalesOrgList
} from "../../services/queries"
import { PAGINATION } from "../../utils/Constant"
import { convertDateTimeByFormat, formatPrice, getActivityIdByPathname } from "../../utils/utils"
import UploadListPrice from "./UploadListPrice"

const ListPriceUpload = () => {
    const activityId = getActivityIdByPathname(location?.pathname)
    const permissionDetails = userRoles().findUserRolesForPage(activityId[0]?.activity_id)
    const orderBy = "ASC"
    const [loader, setLoader] = useState(false)

    const [customsearchtext, setcustomsearchtext] = useState("")
    const [pagination, setPagination] = useState(PAGINATION)
    const[pageSize,setPageSize]= useState(pagination.pageSize)
    
    const { t } = useTranslation()
    const countryDetail = sessionStorage?.getItem("countryDetails") && JSON.parse(sessionStorage?.getItem("countryDetails"))

    const column = [
        {
            Header: t("Pricing.salesOrgCode"),
            accessor: "sales_org"
        },
        {
            Header: t("Pricing.partNoCode"),
            accessor: "article_no"
        },
        {
            Header: t("Pricing.eanLabel"),
            accessor: "ean"
        },
        {
            Header: t("Pricing.currency"),
            accessor: "currency"
        },
        {
            Header: t("Pricing.priceTableId"),
            accessor: "table_id"
        },
        {
            Header: t("Pricing.priceLevelIdentifier"),
            accessor: "identifier"
        },
        {
            Header: t("Pricing.listPrice"),
            //accessor: "price",
            Cell: ({ row }) => {
                return (
                    <span>
                        { (countryDetail && countryDetail.length>0) ? formatPrice(row.original.price) : row.original.price }
                    </span>
                )
            }
        },
        {
            Header: t("Pricing.validityFrom"),
            Cell: ({ row }) => {
                return (
                    <span>
                        { convertDateTimeByFormat(row.original.valid_from, true) }
                    </span>
                )
            }
        },
        {
            Header: t("Pricing.validityTo"),
            Cell: ({ row }) => {
                return (
                    <span>
                        { convertDateTimeByFormat(row.original.valid_to, true) }
                    </span>
                )
            }
        },
        {
            Header: t("Pricing.source"),
            accessor: "source",
            styles: "capitalize"
        }
    ]

    const [data, setData] = useState([])
    const [totalRecords, setTotalRecords] = useState(0)
    const [showPagination, setShowPagination] = useState(true)
    const [showUploadModal, setShowUploadModal] = useState(false)

    const [newCombineFilter, setNewCombineFilter] = useState({
        currencyList: [],
        salesOrgList: [],
        partNumberList: [],
        priceTableIdList: [],
        priceLevelIdentifierList: [],
        eanNumberList: [],
        validityFrom: "",
        validityTo: ""
    })
    const [filterValueDefault, setFilterValueDefault] = useState({
        currencyList: null,
        salesOrgList: null,
        partNumberList: null,
        priceTableIdList: null,
        priceLevelIdentifierList: null,
        eanNumberList: null,
        validityFrom: "",
        validityTo: ""
    })

    const { data: currencyList } = useGetCurrenyList()
    const { data: salesOrgs } = useGetSalesOrgList()
    const { data: priceTableIds } = useGetPriceTableIds()
    const { data: priceLevelIdentifiers } = useGetPriceLevelIdentifiers()
    const { data: eanNumbers } = useGetEanNumbers()

    const currencyOption = currencyList?.map((obj) => ({
        value: obj.name,
        label: obj.name
    }))
    const salesOrgOptions = salesOrgs?.map((obj) => ({
        value: obj.org_code,
        label: obj.org_code
    }))
    const priceTableIdOptions = priceTableIds?.map((obj) => ({
        value: obj,
        label: obj
    }))
    const priceLevelIdentifierOptions = priceLevelIdentifiers?.map((obj) => ({
        value: obj,
        label: obj
    }))
    const eanNumberOptions = eanNumbers?.map((obj) => ({
        value: obj,
        label: obj
    }))
    
    const { data: listPrice = [], status } = useGetAllListPrice(
        pagination.pageIndex,
        pageSize || pagination.pageSize,
        orderBy,
        customsearchtext,
        newCombineFilter
    )
    
    useEffect(() => {
        if (listPrice?.data) {
            setData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(listPrice.data)) {
                    return listPrice?.data || []
                }
                return prevData
            })
            setTotalRecords((prevTotal) => {
                if (prevTotal !== listPrice?.total_count) {
                    return listPrice?.total_count
                }
                return prevTotal
            })
            setLoader(false)
        }
    }, [listPrice, customsearchtext])

    const onPaginationClicked  = (index) => {
        setPagination({ ...pagination, pageIndex: index })
    }

    const onCustomSearch = async (searchText) => {
        setcustomsearchtext(searchText)
        setPagination({ ...pagination, pageIndex: 1 })
    }


    //*************** Upload start ****************/
    const onUpload = () => {
        setShowUploadModal(true)
    }

    const onUploadClose = () => {
        setShowUploadModal(false)
    }
    //*************** Upload start ****************/


    //*************** Filter start ****************/
    const [showFilterModal, setShowFilterModal] = useState(false)
    const [isFilteredValue, setIsFilteredValue] = useState(false)
    const [filter, setFilter] = useState({
        currencyList: [],
        salesOrgList: [],
        partNumberList: [],
        priceTableIdList: [],
        priceLevelIdentifierList: [],
        eanNumberList: [],
        validityFrom: "",
        validityTo: ""
    })
    const [filterValueOnSelectDefault, setFilterValueOnSelectDefault] = useState({
        currencyList: null,
        salesOrgList: null,
        partNumberList: null,
        priceTableIdList: null,
        priceLevelIdentifierList: null,
        eanNumberList: null,
        validityFrom: null,
        validityTo: ""
    })

    useEffect(() => {
        const isFilterApplied = newCombineFilter?.currencyList?.length > 0 || 
                                newCombineFilter?.salesOrgList?.length > 0 || 
                                newCombineFilter?.partNumberList?.length > 0 || 
                                newCombineFilter?.priceTableIdList?.length > 0 || 
                                newCombineFilter?.priceLevelIdentifierList?.length > 0 || 
                                newCombineFilter?.eanNumberList?.length > 0 || 
                                newCombineFilter?.validityFrom || 
                                newCombineFilter?.validityTo
        setIsFilteredValue(isFilterApplied)
    }, [newCombineFilter])

    const onFilterApply = () => {
        setFilterValueDefault(filterValueOnSelectDefault)
        setNewCombineFilter(filter)
        setShowFilterModal(false)
        setPagination({
            pageIndex: 1,
            pageSize: 10
        })
    }

    const handleFilterClick = () => {
        setShowFilterModal(true)
    }

    const onSelectFilterChange = (selectedOption, filterType) => {
        const filterValues = Array.isArray(selectedOption) ? 
            selectedOption.map((option) => option.value) : [selectedOption?.value]

        setFilter((data) => {
            return {
                ...data,
                [filterType]: filterValues
            }
        })
        
        setFilterValueOnSelectDefault({
            ...filterValueOnSelectDefault,
            [filterType]: selectedOption
        })
    }

    const onInputFilterChange = ( value, name ) => {
        setFilter((data) => {
            return {
                ...data,
                [name]: value ? value : ""
            }
        })
        setFilterValueOnSelectDefault((data) => {
            return {
                ...data,
                [name]: value ? value : ""
            }
        })
    }

    const closeFilter = () => {
        setShowFilterModal(false)
    }

    const resetFilter = () => {
        setNewCombineFilter({
            currencyList: [],
            salesOrgList: [],
            partNumberList: [],
            priceTableIdList: [],
            priceLevelIdentifierList: [],
            eanNumberList: [],
            validityFrom: "",
            validityTo: ""
        })
        setFilterValueOnSelectDefault({
            currencyList: null,
            salesOrgList: null,
            partNumberList: null,
            priceTableIdList: null,
            priceLevelIdentifierList: null,
            eanNumberList: null,
            validityFrom: "",
            validityTo: ""
        })
        setFilterValueDefault({
            currencyList: null,
            salesOrgList: null,
            partNumberList: null,
            priceTableIdList: null,
            priceLevelIdentifierList: null,
            eanNumberList: null,
            validityFrom: "",
            validityTo: ""
        })
        setFilter({
            currencyList: [],
            salesOrgList: [],
            partNumberList: [],
            priceTableIdList: [],
            priceLevelIdentifierList: [],
            eanNumberList: [],
            validityFrom: "",
            validityTo: ""
        })
        setPagination({
            pageIndex: 1,
            pageSize: 10
        })
        setShowFilterModal(false)
    }
    //*************** Filter end ****************/

    
    return (
        <>
            <>
                <div className="flex flex-col bg-white py-4 rounded-lg gap-4 border border-secondary-300">
                    <Table
                        columns={ column }
                        data={ data }
                        title={ t("Pricing.listPriceUpload") }
                        downloadFeature={ false }
                        translateFeature={ false }
                        filterFeature={ true }
                        setShowPagination={ setShowPagination }
                        onCustomSearch={ onCustomSearch }
                        isCustomSearch={ true }
                        customsearchtext={ customsearchtext }
                        status={ status }
                        loader={ loader }
                        permissionDetails={ permissionDetails }
                        addNewFeature={ true }
                        addNewButtonTitle={ t("Pricing.uploadPrice") }
                        onAddNew={ onUpload }
                        handleFilterClick={ handleFilterClick }
                        isFilteredValue = { isFilteredValue }
                    />
                    { showPagination && (
                        <Pagination
                            totalrecords={ totalRecords }
                            PaginationState={ pagination }
                            onPaginationClicked ={ onPaginationClicked  }
                            pageSize={ pageSize }
                            setPageSize={ setPageSize }
                        />
                    ) }
                </div>
            </>

            <>
                { showFilterModal && (
                    <Modal
                        title={ t("common.filter") }
                        actionTitle={ t("common.apply") }
                        closeTitle={ t("common.clearAllFilter") }
                        onAction={ onFilterApply }
                        onClose={ resetFilter }
                        isCloseOnTop={ true }
                        WrapperClass={ "max-w-[416px] pt-4" }
                        onTopClose={ closeFilter }
                        CloseButtonDisabled = { !isFilteredValue }
                    >
                        <FilterListPriceUpload
                            currencyOption={ currencyOption }
                            salesOrgOptions={ salesOrgOptions }
                            priceTableIdOptions={ priceTableIdOptions }
                            priceLevelIdentifierOptions={ priceLevelIdentifierOptions }
                            onSelectFilterChange={ onSelectFilterChange }
                            onInputFilterChange={ onInputFilterChange }
                            filterValueDefault={ filterValueOnSelectDefault }
                        />
                    </Modal>
                ) }
            </>

            <>
                { showUploadModal && (
                    <Modal
                        title={ t("Pricing.uploadPrices") }
                        isCloseOnTop={ true }
                        onTopClose={ onUploadClose }
                    >
                        <UploadListPrice />
                    </Modal>
                ) }
            </>
        </>
    )
}

export default ListPriceUpload
